import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64053250"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-edit" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "order-edit__block mt-6 flex flex-col justify-center items-center text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-gray-400 font-semibold text-sm" }, "Загрузка данных о заказе...", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 font-semibold text-sm" }, " Произошла ошибка при получении данных о заказе ", -1))
const _hoisted_7 = { class: "order-edit__block mt-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block__title" }, "Компания", -1))
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "text-blue-600 font-semibold" }
const _hoisted_11 = { class: "order-edit__block mt-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block__title" }, "Отправитель", -1))
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = { class: "text-blue-600 font-semibold" }
const _hoisted_15 = { class: "mt-2 text-sm" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-user mr-2" }, null, -1))
const _hoisted_18 = { class: "block" }
const _hoisted_19 = { class: "flex items-center mt-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-mobile mr-3" }, null, -1))
const _hoisted_21 = { class: "block" }
const _hoisted_22 = { class: "flex items-center mt-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-map-marker-alt mr-3" }, null, -1))
const _hoisted_24 = { class: "block" }
const _hoisted_25 = { class: "mt-3 flex items-center justify-end" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_templates_actions = _resolveComponent("templates-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_step_date = _resolveComponent("step-date")!
  const _component_step_receivers = _resolveComponent("step-receivers")!
  const _component_step_cargo = _resolveComponent("step-cargo")!
  const _component_step_update = _resolveComponent("step-update")!
  const _component_order_receivers = _resolveComponent("order-receivers")!
  const _component_completed_cargos = _resolveComponent("completed-cargos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_templates_actions, {
          key: 0,
          "is-create": false,
          "is-delete": false,
          "is-sender": true,
          "is-update": _ctx.actions_state.is_update,
          loading: _ctx.actions_state.is_actions_loading,
          "company-id": _ctx.order_state.order.company_id,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onUpdate: _ctx.onSenderUpdate
        }, null, 8, ["is-update", "loading", "company-id", "initial-value", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        title: `Редактирование заказа (ID: ${_ctx.$route.params.order_id})`
      }, null, 8, ["title"]),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    (!_ctx.order_state.is_loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.order_state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_5
              ], 64))
            : (_ctx.order_state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_6,
                  _createVNode(_component_the_button, {
                    class: "primary small mt-1",
                    loading: _ctx.order_state.is_loading,
                    onClick: _ctx.loadOrder
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.order_state.order.company), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.order_state.order.sender.title), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.order_state.order.sender.full_name), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("span", _hoisted_21, [
                    (_ctx.order_state.order.sender.additional_phone)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.order_state.order.sender.phone) + ", " + _toDisplayString(_ctx.order_state.order.sender.additional_phone), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.order_state.order.sender.phone), 1)
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.order_state.order.sender.full_address), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_the_button, {
                  class: "primary small text",
                  disabled: _ctx.state.is_updating_order || _ctx.state.is_order_updated,
                  onClick: _ctx.startSenderUpdate
                }, {
                  default: _withCtx(() => [
                    _hoisted_26,
                    _createTextVNode(" Редактировать ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ])
          ])
        ], 64)),
    _createVNode(_component_step_date, {
      class: "mt-6",
      "order-id": Number(_ctx.$route.params.order_id),
      "step-number": 1,
      opened: _ctx.order_state.is_loaded,
      disabled: _ctx.state.is_updating_order || _ctx.state.is_order_updated,
      date: _ctx.order_state.order.take_date,
      period: _ctx.order_state.order.period_id,
      "status-id": _ctx.order_state.order.status_id,
      onReset: _ctx.onDateReset,
      onSubmit: _ctx.onDateSubmit
    }, null, 8, ["order-id", "opened", "disabled", "date", "period", "status-id", "onReset", "onSubmit"]),
    _createVNode(_component_step_receivers, {
      class: "mt-6",
      "step-number": 2,
      opened: _ctx.order_state.is_loaded,
      "sender-id": _ctx.order_state.order.sender.id,
      "sender-city-id": _ctx.order_state.order.sender.city_id,
      "company-id": _ctx.order_state.order.company_id,
      receiver: _ctx.state.receiver,
      disabled: _ctx.state.is_updating_order || _ctx.state.is_order_updated,
      "selected-receivers-ids": _ctx.selectedReceiversIds,
      "is-update": _ctx.state.is_updating_created_cargo,
      onSubmit: _ctx.onReceiverSubmit,
      onReset: _ctx.onReceiverReset,
      onReceiverUpdated: _ctx.onReceiverUpdated
    }, null, 8, ["opened", "sender-id", "sender-city-id", "company-id", "receiver", "disabled", "selected-receivers-ids", "is-update", "onSubmit", "onReset", "onReceiverUpdated"]),
    _createVNode(_component_step_cargo, {
      class: "mt-6",
      "step-number": 3,
      opened: _ctx.isReceiverSelected,
      "is-update": _ctx.state.is_updating_cargo,
      "is-update-created-cargo": _ctx.state.is_updating_created_cargo,
      "updating-cargo-index": _ctx.state.updating_cargo_index,
      "updating-cargo": _ctx.state.updating_cargo,
      disabled: _ctx.state.is_updating_order || _ctx.state.is_order_updated,
      "take-date": _ctx.order_state.order.take_date,
      "period-id": _ctx.order_state.order.period_id,
      "invoice-id": _ctx.state.updating_cargo_id,
      "company-id": _ctx.order_state.order.company_id,
      "receiver-city-type": _ctx.state.receiver ? _ctx.state.receiver.city_type : null,
      onSubmit: _ctx.onCargoSubmit,
      onCancelUpdate: _ctx.cancelUpdateCargo
    }, null, 8, ["opened", "is-update", "is-update-created-cargo", "updating-cargo-index", "updating-cargo", "disabled", "take-date", "period-id", "invoice-id", "company-id", "receiver-city-type", "onSubmit", "onCancelUpdate"]),
    (_ctx.state.completed_cargos.length >= 5 && !_ctx.state.is_order_updated)
      ? (_openBlock(), _createBlock(_component_step_update, {
          key: 3,
          class: "mt-6",
          loading: _ctx.state.is_updating_order,
          orderId: _ctx.$route.params.order_id,
          onSubmit: _ctx.onSubmitOrder
        }, null, 8, ["loading", "orderId", "onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_order_receivers, {
      class: "mt-6",
      disabled: _ctx.state.is_updating_order || _ctx.state.is_order_updated,
      receivers: _ctx.order_state.order.receivers,
      "without-update": "",
      onUpdateCargo: _ctx.onStartUpdateCreatedCargo
    }, null, 8, ["disabled", "receivers", "onUpdateCargo"]),
    _createVNode(_component_completed_cargos, {
      class: _normalizeClass({
                'mt-6': _ctx.state.completed_cargos.length < 5,
                'mt-3': _ctx.state.completed_cargos.length >= 5,
            }),
      cargos: _ctx.state.completed_cargos,
      disabled: _ctx.state.is_updating_order || _ctx.state.is_order_updated,
      onDeleteCargo: _ctx.onDeleteCargo,
      onUpdateCargo: _ctx.onStartUpdateCargo
    }, null, 8, ["class", "cargos", "disabled", "onDeleteCargo", "onUpdateCargo"]),
    _createVNode(_component_step_update, {
      class: "mt-3",
      updated: _ctx.state.is_order_updated,
      loading: _ctx.state.is_updating_order,
      orderId: _ctx.$route.params.order_id,
      onSubmit: _ctx.onSubmitOrder,
      onUpdateOrder: _ctx.resetOrder
    }, null, 8, ["updated", "loading", "orderId", "onSubmit", "onUpdateOrder"])
  ]))
}